import { ACTIONS, ROLE } from '../utils/constants'

const permissions = new Map()

permissions.set(ACTIONS.ADMINISTRATOR_MODULE.VIEW_ADMINISTRATOR_MODULE, [
  ROLE.SUPERADMIN,
  ROLE.GOODS.ADMIN,
  ROLE.GOODS.OPERATIONS,
  ROLE.PROPS.ADMIN,
  ROLE.PROPS.OPERATIONS,
])
permissions.set(ACTIONS.AUCTIONEER_MODULE.VIEW_AUCTIONEER_MODULE, [
  ROLE.SUPERADMIN,
  ROLE.GOODS.ADMIN,
  ROLE.GOODS.COMMERCIAL,
  ROLE.PROPS.ADMIN,
  ROLE.PROPS.COMMERCIAL,
])
permissions.set(ACTIONS.USER_CONTROL_MODULE.VIEW_USER_CONTROL_MODULE, [
  ROLE.SUPERADMIN,
  ROLE.GOODS.ADMIN,
  ROLE.GOODS.FINANCE,
  ROLE.PROPS.ADMIN,
  ROLE.PROPS.FINANCE,
])
permissions.set(ACTIONS.ROOM_OFFER_MODULE.VIEW_ROOM_OFFER_MODULE, [
  ROLE.SUPERADMIN,
  ROLE.GOODS.ADMIN,
  ROLE.GOODS.OPERATIONS,
  ROLE.PROPS.ADMIN,
  ROLE.PROPS.OPERATIONS,
])
permissions.set(ACTIONS.ROOM_MODULE.VIEW_ROOM_MODULE, [
  ROLE.SUPERADMIN,
  ROLE.GOODS.ADMIN,
  ROLE.GOODS.OPERATIONS,
  ROLE.PROPS.ADMIN,
  ROLE.PROPS.OPERATIONS,
])

permissions.set(ACTIONS.GUEST_SWITCH.VIEW_GUEST_SWITCH, [
  ROLE.GOODS.ADMIN,
  ROLE.PROPS.ADMIN,
  ROLE.SUPERADMIN,
])
permissions.set(ACTIONS.USER_ENTRY_MODULE.USER_ENTRY_MODULE, [
  ROLE.GOODS.ADMIN,
  ROLE.SUPERADMIN,
])
permissions.set(ACTIONS.CLIENT_MODULE.VIEW_OFFER_BUTTON, [
  ROLE.CLIENT,
])
permissions.set(ACTIONS.CLIENT_MODULE.VIEW_AUCTION_POLL, [
  ROLE.CLIENT,
])

permissions.set(ACTIONS.ROBIN_HOOD_MODULE.VIEW_ROBIN_HOOD_MODULE, [ROLE.SUPERADMIN])

export const hasPermission = (action, role) => {
  if (permissions.has(action)) {
    return permissions.get(action).includes(role)
  }
  return false
}
export const getRolebyUserData = (user) => {
  if (
    user.externalId === 1470
    ||
    user.externalId === 13635
    ||
    user.externalId === 1445
    ||
    user.externalId === 14546
    ||
    user.externalId === 1448) {
    return ROLE.SUPERADMIN
  }
  else if (user.isGuest === true) {
    return ROLE.GUEST
  }
  else if (user.roleId === 5) {
    return ROLE.CLIENT
  } else if (user.roleId === 6) {
    return ROLE.GUEST
  }
  else if (user.areaId === 1) {
    switch (user.roleId) {
      case 1:
        return ROLE.GOODS.ADMIN
      case 2:
        return ROLE.GOODS.OPERATIONS
      case 3:
        return ROLE.GOODS.FINANCE
      case 4:
        return ROLE.GOODS.COMMERCIAL
      default:
        return ROLE.GUEST
    }
  } else if (user.areaId === 2) {
    switch (user.roleId) {
      case 1:
        return ROLE.PROPS.ADMIN
      case 2:
        return ROLE.PROPS.OPERATIONS
      case 3:
        return ROLE.PROPS.FINANCE
      case 4:
        return ROLE.PROPS.COMMERCIAL
      default:
        return ROLE.GUEST
    }
  }
}
